import { UserRound } from 'lucide-react';

const UserMessage = ({ content }) => {
  if (content.trim() === '') {
    return;
  }
  return (
    <div className="flex w-full h-fit gap-2">
      <div className="flex-shrink-0 mt-1 p-2 rounded-full bg-sky-700/80 size-9 flex items-center justify-center">
        <UserRound size={20} strokeWidth={2.5} />
      </div>
      <div className="bg-[#A8B2C1]/80 text-gray-800 px-3 py-2 rounded-lg min-w-0 break-words">{content}</div>
    </div>
  );
};

export default UserMessage;
